import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useEffect, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
import { _get, dataToObjWithNotFound } from "nood-comp/src/net/xhr";
import FlexCenterCenter from "nood-comp/src/comp/ui/containers/FlexCenterCenter";
import SpinnerApple from "nood-comp/src/comp/ui/spinner/Spinner.Apple";
import Div from "nood-comp/src/comp/ui/containers/Div";
import FlexVertical from "nood-comp/src/comp/ui/containers/flex-boxes/FlexVertical";
import Row from "nood-comp/src/comp/ui/containers/flex-boxes/Row";
import Tag from "nood-comp/src/comp/ui/tag/Tag";
import Text from "nood-comp/src/comp/text/Text";
import ElapsedTime from "nood-comp/src/util/date/ElapsedTime";
import { date_util } from "nood-comp/src/util/date/DateUtil";
import Spacer from "nood-comp/src/comp/ui/spacer/Spacer";
import JSONViewer from "nood-comp/src/comp/text/JSONViewer";
import RecordNotFound from "nood-comp/src/comp/no-records/RecordNotFound";
import CenteredColumnWidth from "nood-comp/src/comp/ui/containers/CenteredColumnWidth";
import { useIAppContext } from "nood-comp/src/context-providers/IAppContextProvider";
export default function AuditLog(props) {
  var _useIAppContext;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    auditLog = _useState2[0],
    setAuditLog = _useState2[1];
  var id = useURLParam("id");
  var lightOrDark = (_useIAppContext = useIAppContext()) === null || _useIAppContext === void 0 ? void 0 : _useIAppContext.lightOrDark;
  useEffect(function () {
    if (id) {
      _get("/audit-log/".concat(id), function (response) {
        dataToObjWithNotFound(response, setAuditLog);
      });
    }
  }, [id]);
  var __normalize = function __normalize(raw) {
    if (!raw) return '{}';
    try {
      JSON.parse(raw);
      return raw;
    } catch (e) {
      var escaped = raw;
      escaped = escaped.replaceAll("\\'", "'");
      escaped = escaped.replace(/\s{2,}/g, ' ');
      escaped = escaped.replace(/\n/g, '');
      return escaped;
    }
  };
  var __parse = function __parse(rawJSON) {
    try {
      return JSON.parse(__normalize(rawJSON));
    } catch (e) {
      return {};
    }
  };
  if (auditLog === void 0) return /*#__PURE__*/React.createElement(FlexCenterCenter, null, /*#__PURE__*/React.createElement(SpinnerApple, null));
  // @ts-ignore
  if (auditLog === 'NOT_FOUND') {
    return /*#__PURE__*/React.createElement(CenteredColumnWidth, {
      width: 300
    }, /*#__PURE__*/React.createElement(Spacer, {
      mtop: 50
    }), /*#__PURE__*/React.createElement(RecordNotFound, null));
  }
  return /*#__PURE__*/React.createElement(Div, {
    pad: 20
  }, (auditLog === null || auditLog === void 0 ? void 0 : auditLog.id) && /*#__PURE__*/React.createElement(FlexVertical, {
    gap: 3
  }, /*#__PURE__*/React.createElement(Row, {
    verticalAlign: "center"
  }, /*#__PURE__*/React.createElement(Tag, {
    monospace: true,
    value: auditLog.method,
    style: {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      height: "23px",
      display: "flex",
      alignItems: "center",
      color: "#a5c73e",
      backgroundColor: "transparent",
      border: "1px solid var(--shade-10)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      border: "1px solid var(--shade-10)",
      height: "23px",
      borderLeft: 0,
      display: "flex",
      alignItems: "center",
      paddingLeft: "5px",
      paddingRight: "5px"
    }
  }, /*#__PURE__*/React.createElement(Text, {
    monospace: true,
    size: 12
  }, auditLog.response_code)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      height: "23px",
      border: "1px solid var(--shade-10)",
      borderLeft: 0,
      paddingLeft: "5px",
      paddingRight: "5px",
      borderTopRightRadius: "var(--roundness)",
      borderBottomRightRadius: "var(--roundness)"
    }
  }, /*#__PURE__*/React.createElement(Text, {
    monospace: true,
    size: 11
  }, auditLog.browser_path || auditLog.browser_query_string ? /*#__PURE__*/React.createElement(React.Fragment, null, auditLog.browser_path, auditLog.browser_query_string) : /*#__PURE__*/React.createElement(React.Fragment, null, auditLog.query_string)))), /*#__PURE__*/React.createElement(Row, {
    gap: 5
  }, /*#__PURE__*/React.createElement(ElapsedTime, {
    datetime: auditLog.created_dt
  }), /*#__PURE__*/React.createElement(Text, {
    secondary: true,
    size: 13
  }, date_util.elt_title(auditLog.created_dt))), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 15
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FlexVertical, null, /*#__PURE__*/React.createElement("div", null, "Request Body ", auditLog.request_body === void 0 || auditLog.request_body === null && /*#__PURE__*/React.createElement(Text, {
    secondary: true
  }, "No request body")), auditLog.request_body && /*#__PURE__*/React.createElement("div", {
    className: "AuditLog__ui.code evtv0qo8 ev1y7ric0 evxwrc4x ev14odnwx evgh8whm ev1ey7xld ev1j6dyjg eveaf4i8 ev1vvkbs ev1mzt3pk"
  }, /*#__PURE__*/React.createElement(JSONViewer, {
    object: __parse(auditLog.request_body),
    theme: lightOrDark
  })))), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 15
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FlexVertical, null, /*#__PURE__*/React.createElement("div", null, "Response Body"), /*#__PURE__*/React.createElement("div", {
    className: "AuditLog__ui.code evtv0qo8 ev1y7ric0 evxwrc4x ev14odnwx evgh8whm ev1ey7xld ev1j6dyjg eveaf4i8 ev1vvkbs ev1mzt3pk"
  }, auditLog.response_body && /*#__PURE__*/React.createElement(JSONViewer, {
    object: __parse(auditLog.response_body),
    theme: lightOrDark
  })))), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 15
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FlexVertical, null, /*#__PURE__*/React.createElement("div", null, "Request JWT"), /*#__PURE__*/React.createElement("div", {
    className: "AuditLog__ui.code evtv0qo8 ev1y7ric0 evxwrc4x ev14odnwx evgh8whm ev1ey7xld ev1j6dyjg eveaf4i8 ev1vvkbs ev1mzt3pk"
  }, auditLog.jwt))), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 20
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FlexVertical, null, /*#__PURE__*/React.createElement("div", null, "User Agent"), /*#__PURE__*/React.createElement("div", {
    className: "AuditLog__ui.code evtv0qo8 ev1y7ric0 evxwrc4x ev14odnwx evgh8whm ev1ey7xld ev1j6dyjg eveaf4i8 ev1vvkbs ev1mzt3pk"
  }, auditLog.user_agent)))));
}
AuditLog.propTypes = {
  // proptypes
};

// @ts-ignore
_inject(".evtv0qo8{border:1px solid var(--shade-10)}", 1000);
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".ev14odnwx{padding:5px}", 1000);
_inject(".evgh8whm{color:var(--shade-60)}", 3000);
_inject(".ev1ey7xld{font-family:monospace}", 3000);
_inject(".ev1j6dyjg{font-size:11px}", 3000);
_inject(".eveaf4i8{white-space:normal}", 3000);
_inject(".ev1vvkbs{word-wrap:break-word}", 3000);
_inject(".ev1mzt3pk{overflow-wrap:break-word}", 3000);